export default __webpack_public_path__ + "static/media/hht2_ep07_timeline_q01_b.3f8f8018.png";